import { Container, ContainerProperties, ContainerState } from '@adobe/aem-react-editable-components';
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager';
import { Alignment, PreTitleVariation } from '../../types/enums';
import { ThemeMode } from '../../theme/ATCOPaletteColor';
import { TypographyVariants } from '../../theme/TypographyVariants';
import Grid from './Grid';

interface gridComponentProps extends ContainerProperties {
    publishInstance: any;
    xsSize: string;
    smSize: string;
    mdSize: string;
    lgSize: string;
    itemSizes: boolean;
    preTitleOptions: PreTitleVariation;
    preTitle: string;
    title: string;
    titleTypography: TypographyVariants;
    description: string;
    orientation: Alignment;
    isOnPageLevel: boolean;
    color: ThemeMode;
}

interface gridComponentState extends ContainerState {
    gridClassNames: string;
}

export class GridWrapper extends Container<gridComponentProps, gridComponentState> {
    /**
     * The attributes that will be injected in the root element of the container
     *
     * @returns {Object} - the attributes of the container
     */
    get containerProps(): { [key: string]: string } {
        const containerProps = super.containerProps;
        if (typeof window !== 'undefined' && (AuthoringUtils.isPreviewMode() || this.props.publishInstance === 'true')) {
            containerProps.item = 'true';
            containerProps.xs = this.props.xsSize;
            containerProps.sm = this.props.smSize;
            containerProps.md = this.props.mdSize;
            containerProps.lg = this.props.lgSize;
        }
        return containerProps;
    }

    render(): JSX.Element {
        const { xsSize, smSize, mdSize, lgSize, preTitleOptions, preTitle, title, description, titleTypography, color, orientation, isOnPageLevel, itemSizes } = this.props;

        return (
            <Grid
                childComponents={this.childComponents}
                placeholderComponent={this.placeholderComponent}
                itemSizes={itemSizes}
                xsSize={parseInt(xsSize, 10)}
                smSize={parseInt(smSize, 10)}
                mdSize={parseInt(mdSize, 10)}
                lgSize={parseInt(lgSize, 10)}
                preTitleOptions={preTitleOptions}
                preTitle={preTitle}
                title={title}
                description={description}
                titleTypography={titleTypography}
                color={color}
                orientation={orientation}
                isOnPageLevel={isOnPageLevel}
            />
        );
    }
}

export default GridWrapper;
